import { useEffect } from "react";

export const SITE_ORIGIN = "https://daycamp.cn";

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: string;
  jsonLd?: Record<string, unknown>[];
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({
  title,
  description,
  keywords,
  path,
  type = "website",
  jsonLd = [],
}: SEOProps) {
  const jsonLdKey = JSON.stringify(jsonLd);

  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    document.title = title;

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow");
    setCanonical(url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "黑料百科");
    setMeta("property", "og:locale", "zh_CN");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    document.querySelectorAll('script[data-seo-jsonld="true"]').forEach((node) => node.remove());
    const parsed = JSON.parse(jsonLdKey) as Record<string, unknown>[];
    parsed.forEach((item) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.textContent = JSON.stringify(item);
      document.head.appendChild(script);
    });
  }, [title, description, keywords, path, type, jsonLdKey]);
}